import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, Autocomplete, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './position-assign.css'
import SearchIcon from "@mui/icons-material/Search";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import editIcon from "../../assets/edit.svg";
import { DataGrid } from '@mui/x-data-grid';

const PositionAssignment = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [deleteModal, setDeleteModal] = useState(false)
    const [assignmentDrop, setAssignmentDrop] = useState([]);
    const [assignment, setAssignment] = useState('');
    const [assignmentList, setAssignmentList] = useState('');
    const [searchResult, setSearchResult] = useState('');
		const [position, setPosition] = useState(null);
		const [positionDrop, setPositionDrop] = useState([]);
		const [group, setGroup] = useState(null);
		const [groupDrop, setGroupDrop] = useState([]);
		const [battalion, setBattalion] = useState(null);
		const [battalionDrop, setBattalionDrop] = useState([]);
		const [district, setDistrict] = useState(null);
		const [districtDrop, setDistrictDrop] = useState([]);
		const [vehicle, setVehicle] = useState(null);
		const [vehicleDrop, setVehicleDrop] = useState([]);
		const [shift, setShift] = useState(null);
		const [shiftDrop, setShiftDrop] = useState([]);
		const [assignId, setAssignId] = useState(null);
		const [deleteId, setDeleteId] = useState('');
		const [isEdit, setIsEdit] = useState(false);
    const [endDate, setEndDate] = useState(null);

    const columns = [
			{
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
          							<img src={editIcon} alt="editIcon" style={{width: '20px', cursor: 'pointer'}}
												 onClick={() => {
															getAssignmentData(params?.row?.ID)
															setAssignId(params?.row?.ID)
															setIsEdit(true)
															window.scrollTo(1,1)
															}} 
												/>
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => {
															setDeleteId(params?.row?.ID)
                              setDeleteModal(true)
                            }}
                        />
                    </Box>
                );
            },
        },

				{
            field: 'Assignment_date', headerName: 'Effective Date', flex: 1, minWidth: 200,
            valueGetter: (params) => {
                return moment(params?.row?.Effective_Date).format('MM/DD/YY');
            }
        },
				
				{
						field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 200,
						renderCell: (params) => {
								return (
									params?.row?.Assignment_Name
								)
						}
				},

				{
            field: 'Position', headerName: 'Position', flex: 1, minWidth: 200,
            valueGetter: (params) => { 
							return (params?.row?.Position_Name)
						}
        },

				{
            field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Shift_Name
                )
            }
        },

				{
            field: 'Vehicle', headerName: 'Vehicle', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Vehicle_Name
                )
            }
        },

        {
            field: 'Group', headerName: 'Group', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Group_Name
                )
            }
        },

				{
            field: 'Battalion', headerName: 'Battalion', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Batallion_Name
                )
            }
        },

				{
            field: 'District', headerName: 'District', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.District_Name
                )
            }
        },

				{
            field: 'End_date', headerName: 'End Date', flex: 1, minWidth: 200,
            valueGetter: (params) => {
							return params?.row?.End_Date 
              ? moment(params?.row?.End_Date).format('MM/DD/YY')
							: "" ;
						}
        },
    ]

	const addAssignment = () => {
        const body = {
						"Effective_Date" : moment(date).format('YYYY-MM-DD'),
						"End_Date" : endDate ? moment(endDate).format('YYYY-MM-DD') : null,
						"Assignment_Code" : assignment?.value,
						"Position_Code" : position?.value,
						"Group_Code" : group?.value,
						"Battalion_Code" : battalion?.value,
						"District_Code" : district?.value,
						"Vehicle_Code" : vehicle?.value,
						"Shift_Code" : shift?.value
        }
        ApiService.post('/position-assignment/add', body)
            .then((data) => {
                toast.success(data?.message)
                setDate(new Date());
								setEndDate(null);
                setAssignment('');
								setPosition(null)
								setGroup(null)
								setBattalion(null)
								setDistrict(null)
								setVehicle(null)
								setShift(null)
                getAssignmentList()
            })
            .catch((error) => {
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.message)
                }
            })
    }

		const getPositionDropown = () => {
			setLoading(true);
			ApiService.get('/positions-list')
				.then(({ data }) => {
					var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
					setPositionDrop(certArr)
					setLoading(false);
				})
				.catch((e) => {
					setLoading(false);
				})
		}

		const getAssignmentDropDown = () => {
		setLoading(true);
		ApiService.get('/getAssignment')
				.then(({ data }) => {
						var assignArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
						setAssignmentDrop(assignArr)
						setLoading(false);
				})
				.catch((e) => {
						setLoading(false);
				})
    }

		const getGroupDropDown = () => {
		setLoading(true);
		ApiService.get("/getGroups")
		.then(({ data }) => {
			var tempArr = []
			Object.keys(data?.data).map(val => (
				tempArr.push({label:data.data[val], value: val})
			))
			setGroupDrop(tempArr)
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getBattalionDropDown = () => {
		setLoading(true);
		ApiService.get("/getBattalions")
		.then(({ data }) => {
				var batArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
				setBattalionDrop(batArr);
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getVehicleDropDown = () => {
		setLoading(true);
		ApiService.get("/getVehicles")
		.then(({ data }) => {
			var vehicleArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
			setVehicleDrop(vehicleArr);
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getAssignmentList = () => {
		ApiService.get('/position-assignment/list')
				.then((data) => {
						const rowsWithIds = data?.data?.data?.map((item, index) => ({
								...item,
								id: index + 1
						})) || [];
						setAssignmentList(rowsWithIds);
						setLoading(false);
				})
				.catch((e) => {
						setLoading(false);
				});
    };

    const deleteAssignment = () => {
        const body = {
            'id': deleteId,
        }
        ApiService.post('/position-assignment/delete', body)
            .then((data) => {
                setDeleteModal(false)
                toast.success(data.message)
                getAssignmentList()
            })
            .catch((err) => {
                toast.error(err?.data?.error)
            })
    }

		const getShiftDropDown = () => {
		ApiService.get('/shiftTypes')
				.then((data) => {
					var shiftArr = data?.data?.data?.map((shift) => { return { label: shift.Shift + " (" + shift.Start_Time?.slice(0,5) + " - " + shift.End_Time?.slice(0,5) + ")", value: shift.ShiftCode } })
					// var shiftArr = data?.data?.data?.map((shift) => ({
    			// label: `${shift.Shift} (${varFormatTime(shift.Start_Time, user?.Time_Format)?.slice(0,5)} - ${varFormatTime(shift.End_Time, user?.Time_Format)?.slice(0,5)})`,
    			// value: shift.ShiftCode
					// }));
					setShiftDrop(shiftArr)
					setLoading(false);
				})
				.catch((err) => {
						console.log(err?.data?.error)
				})
    }

		const updateAssignment = () => {
		const body = {
				"id" : assignId,
				"Effective_Date" : moment(date).format('YYYY-MM-DD'),
				"End_Date" : endDate ? moment(endDate).format('YYYY-MM-DD') : null,
				"Assignment_Code" : assignment?.value,
				"Position_Code" : position?.value,
				"Group_Code" : group?.value,
				"Battalion_Code" : battalion?.value,
				"District_Code" : district?.value,
				"Vehicle_Code" : vehicle?.value,
				"Shift_Code" : shift?.value
		}
		ApiService.post('/position-assignment/update', body)
				.then((data) => {
						toast.success(data?.message)
						setIsEdit(false)
						setDate(new Date());
						setEndDate(null);
						setAssignment('');
						setPosition(null)
						setGroup(null)
						setBattalion(null)
						setDistrict(null)
						setVehicle(null)
						setShift(null)
						getAssignmentList()
				})
				.catch((error) => {
						if (error.status == 422) {
								Object.keys(error.data.errors).map((err) => (
										toast.error(error.data.errors[err][0])
								))
						}
						else {
								toast.error(error.message)
						}
				})
    }

		const getAssignmentData = (id) => {
    if (id) {
      setLoading(true);
		ApiService.get('/position-assignment/show/' + id)
				.then((data) => {
					setLoading(false);
					setDate(new Date(data?.data?.position_assignment?.Effective_Date + "T12:00:00"))
					setEndDate(data?.data?.position_assignment?.End_Date == null ? null : new Date(data?.data?.position_assignment?.End_Date + "T12:00:00"))
					var tempAssign = assignmentDrop.find(a => a.value == data?.data?.position_assignment?.Assignment_Code)
					setAssignment(tempAssign)
					var tempPos = positionDrop.find(a => a.value == data?.data?.position_assignment?.Position_Code)
					setPosition(tempPos)
					var tempGroup = groupDrop.find(a => a.value == data?.data?.position_assignment?.Group_Code)
					setGroup(tempGroup)
					var tempBatt = battalionDrop.find(a => a.value == data?.data?.position_assignment?.Batallion_Code)
					setBattalion(tempBatt)
					var tempDis = districtDrop.find(a => a.value == data?.data?.position_assignment?.District_Code)
					setDistrict(tempDis)
					var tempVeh = vehicleDrop.find(a => a.value == data?.data?.position_assignment?.Vehicle_Code)
					setVehicle(tempVeh)
					var tempShift = shiftDrop.find(a => a.value == data?.data?.position_assignment?.Shift_Code)
					setShift(tempShift)
				})
				.catch((error) => {
						toast.error(error.message)
      			setLoading(false);
				})
			}
    }

    useEffect(() => {
        getAssignmentList()
        getAssignmentDropDown()
				getPositionDropown()
				getGroupDropDown()
				getVehicleDropDown()
				getBattalionDropDown()
				getShiftDropDown()
    }, [])

    useEffect(() => {
        getAssignmentList(false)
    }, [searchResult])

    return (
        <>
            <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                <Grid container spacing={2} className='align-items-center'>

                    {/* Heading */}
                    <Grid item xs={10} md={4}>
                        <Typography variant="h5">Position Assignment</Typography>
                    </Grid>

                    <Grid container className='p-4' spacing={2}>
                        
												{/* Effective Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>Effective Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={moment(date).format('MM/DD/YYYY')}
                                    value={date}
                                    onChange={(e) => setDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Assignment */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Assignment</label>
                            <Autocomplete
                                options={assignmentDrop}
                                onChange={(event, newValue) => setAssignment(newValue)}
                                value={assignment}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Assignment"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

												{/* Position */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Position</label>
                            <Autocomplete
															options={positionDrop}
															onChange={(event, newValue) => setPosition(newValue)}
															value={position}
															renderInput={(params) => (
																<TextField
																	{...params}
																	placeholder="Select Position"
																		sx={{
																				"& .MuiInputBase-root": {
																					height: "48px",
																					fontSize: "14px",
																					display: "flex",
																					alignItems: "center"
																				}
																		}}
																/>
															)}
														/>
                        </Grid>

												{/* Group */}
												{groupDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Group</label>
                            <Autocomplete
                                options={groupDrop}
                                onChange={(event, newValue) => setGroup(newValue)}
                                value={group}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Group"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* Battalion */}
												{battalionDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Battalion</label>
                            <Autocomplete
                                options={battalionDrop}
                                onChange={(event, newValue) => setBattalion(newValue)}
                                value={battalion}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Battalion"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* District */}
												{districtDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>District</label>
                            <Autocomplete
                                options={districtDrop}
                                onChange={(event, newValue) => setDistrict(newValue)}
                                value={district}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select District"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* Vehicle */}
												{vehicleDrop.length > 0 &&
												<Grid item xs={12} sm={6} md={4}>
													<label className='my-2'>Vehicle</label>
													<Autocomplete
															options={vehicleDrop}
															onChange={(event, newValue) => setVehicle(newValue)}
															value={vehicle}
															renderInput={(params) => (
																	<TextField
																			{...params}
																			placeholder="Select Vehicle"
																			variant="outlined"
																			fullWidth
																			size="small"
																			sx={{
																					"& .MuiInputBase-root": {
																							height: "48px",
																							fontSize: "14px",
																							display: "flex",
																							alignItems: "center"
																					}
																			}}
																	/>
															)}
														/>
												</Grid>}

												{/* Shift Rotation */}
												{shiftDrop.length > 0 &&
												<Grid item xs={12} sm={6} md={4}>
													<label className='my-2'>Shift Rotation</label>
													<Autocomplete
															options={shiftDrop}
															onChange={(event, newValue) => setShift(newValue)}
															value={shift}
															renderInput={(params) => (
																	<TextField
																			{...params}
																			placeholder="Select Shift"
																			variant="outlined"
																			fullWidth
																			size="small"
																			sx={{
																					"& .MuiInputBase-root": {
																							height: "48px",
																							fontSize: "14px",
																							display: "flex",
																							alignItems: "center"
																					}
																			}}
																	/>
															)}
														/>
												</Grid>}

												{/* End Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>End Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={endDate ? moment(endDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* Submit/Edit Button */}
                    <Grid container gap={2} className='justify-content-end'>
                        <Grid item xs={6} md={'auto'}>
                            <ButtonTheme 
															className='px-2 mt-1' 
															style={{ marginRight: '24px' }}
															color='primary'
															type='submit' 
															variant="filled" 
                              onClick={() => 
																{if (isEdit == true)
																	updateAssignment()

																else 
																	addAssignment()
																}
															}
                            >
                                {isEdit == true ? "Update" : "Submit"}
                            </ButtonTheme>
                        </Grid>

                    </Grid>
                </Grid>
            </Paper>

            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h6">List of Position Assignment</Typography>
                        </Grid>

                        {/* Search field */}
                        <Grid item xs={12} sm={12} md={3}>
                            <TextField
                                variant="outlined"
                                placeholder="Search"
                                onChange={(e) => setSearchResult(e.target.value)}
                                className="w-100"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        height: '48px',
                                        fontSize: '14px',
                                        marginRight: '10px',
                                    },
                                }}
                            />
                        </Grid>

                    </Grid>

                    {(!assignmentList || assignmentList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Positions assigned
                            </span>
                        </div>
                        :
                        <>
                            <div className='mt-4'>
                                <DataGrid
                                    rows={assignmentList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                />
                            </div>
                        </>
                    }

                    {/* Delete Modal */}
                    <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Assignment</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div style={{ color: '#555555' }}>
                                Are you sure you want to delete this Assignment?
                            </div>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setDeleteModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                        onClick={deleteAssignment}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </Col>

                            </Row>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}
        </>
    )
}

export default PositionAssignment

{/* Schedule Override Button */}
{/* <Grid item xs={6} sm={6} md={'auto'}>
<Link to='/firehouse/schedule-override' style={{ textDecoration: 'none' }}>
<div className={listType == 'Schedule Override' ? 'tab-active px-4' : 'tab-white px-4'}
onClick={() => setListType('Schedule Override')}>
Schedule Override
</div>
</Link>
</Grid> */}

{/* Resource Assignment Button */}
{/* <Grid item xs={6} sm={6} md={'auto'}>
<Link to='/firehouse/resource-assignment' style={{ textDecoration: 'none' }}>
<div className={listType == 'Resource Assignment' ? 'tab-active px-4' : 'tab-white px-4'}
onClick={() => setListType('Resource Assignment')}>
Resource Assignment
</div>
</Link>
</Grid> */}

{/* <Grid item xs={12} sm={6} md={4}>
<label className='my-2'>Resource</label>
<TextField
fullWidth
variant="outlined"
onChange={(e) => setVehicle(e.target.value)}
value={resource}
placeholder="Vehicle"
sx={{
"& .MuiInputBase-root": {
height: "48px",
fontSize: "14px",
display: "flex",
alignItems: "center"
}
}}
/>
</Grid> */}

// const getAssignmentList = (loader = true) => {
//     const body = {
//         'search': searchResult,
//     }
//     if (loader) {
//         setLoading(true);
//     }
//     ApiService.post('/ra/list', body)
//         .then((data) => {
//             const rowsWithIds = data?.data?.map((item, index) => ({
//                 ...item,
//                 id: index + 1
//             })) || [];

//             setAssignmentList(rowsWithIds);
//             setLoading(false);
//         })
//         .catch((e) => {
//             setLoading(false);
//         });
// };